import { WalletContext } from '../providers/WalletProvider'
import { useContext } from 'react'

export default function useWallet() {
  return useContext(WalletContext)
}
